export default __webpack_public_path__ + "static/media/Thaumaturge's Armbands of Prestige.03e8cd08.jpg";